import React from 'react';
import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "LazyCustomerInfoChunks" */ './CustomerInformationConnect'),
    {
        fallback: <div />,
    }
);
